// src/components/DailyReward.js
import React, { useState, useEffect } from 'react';
import { canClaimDailyReward, getTimeUntilNextClaim } from '../utils/time';
import { claimDailyReward } from '../services/api';
import CaseReward from './CaseReward';
const DAILY_REWARD_PRIZES = [
  { type: 'points', value: 50 },
  { type: 'xp_booster', value: 300 }, // <-- ДОБАВЛЕНО
  { type: 'points', value: 75 },
  { type: 'role', value: 3 },
  { type: 'xp_booster', value: 500 }, // <-- ДОБАВЛЕНО
  { type: 'points', value: 100 },
  { type: 'jackpot', value: 'ДЖЕКПОТ' },
  { type: 'points', value: 200 },
  { type: 'role', value: 5 },
  { type: 'xp_booster', value: 1000 }, // <-- ДОБАВЛЕНО
  { type: 'points', value: 500 },
  { type: 'role', value: 7 },
];
export default function DailyReward({ lastClaimed, onRewardClaimed }) {
  const [isClaimable, setIsClaimable] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [timeLeft, setTimeLeft] = useState(''); // <-- Новое состояние для текста таймера

  // --- НОВЫЙ useEffect ДЛЯ ТАЙМЕРА ---
  useEffect(() => {
    // Эта функция будет обновлять таймер
    const updateTimer = () => {
      const canClaim = canClaimDailyReward(lastClaimed);
      setIsClaimable(canClaim);

      if (!canClaim) {
        const msLeft = getTimeUntilNextClaim();
        if (msLeft > 0) {
          const hours = Math.floor((msLeft / (1000 * 60 * 60)) % 24).toString().padStart(2, '0');
          const minutes = Math.floor((msLeft / 1000 / 60) % 60).toString().padStart(2, '0');
          const seconds = Math.floor((msLeft / 1000) % 60).toString().padStart(2, '0');
          setTimeLeft(`${hours}:${minutes}:${seconds}`);
        } else {
          // Если время вышло, снова проверяем возможность получения
          setIsClaimable(canClaimDailyReward(lastClaimed));
        }
      }
    };

    updateTimer(); // Запускаем сразу
    const intervalId = setInterval(updateTimer, 1000); // И потом каждую секунду

    // Очищаем интервал при размонтировании компонента
    return () => clearInterval(intervalId);
  }, [lastClaimed]); // Зависимость от lastClaimed, чтобы таймер перезапустился после получения награды

  const handleClaim = async () => {
    setIsLoading(true);
    setResult(null);
    try {
      const response = await claimDailyReward();
      setResult(response.data);
      
      if (!response.data.caseReward) {
        setTimeout(() => {
          onRewardClaimed();
          setResult(null);
          setIsLoading(false); 
        }, 2000);
      }
    } catch (error) {
      setResult({ message: error.response?.data?.error || 'Произошла ошибка.' });
      setIsLoading(false);
    }
  };
  
  const handleAnimationEnd = () => {
    onRewardClaimed();
    setResult(null);
    setIsLoading(false);
  };

  return (
    <div className={`daily-reward-card card ${isClaimable && !result ? 'claimable' : ''}`}>
      {result?.caseReward ? (
        <CaseReward reward={result.caseReward} onAnimationEnd={handleAnimationEnd} ALL_PRIZES={DAILY_REWARD_PRIZES} />
      ) : (
        <>
          <h5>Ежедневная награда</h5>
          {result?.message ? (
            <p className="reward-message">{result.message}</p>
          ) : (
            <>
              <p>{isClaimable ? 'Доступна новая награда!' : 'Следующая награда через:'}</p>
              <button 
                className="claim-button" 
                onClick={handleClaim}
                disabled={!isClaimable || isLoading}
              >
                {/* --- ИЗМЕНЕНИЕ: Показываем либо текст, либо таймер --- */}
                {isLoading ? 'Получение...' : (isClaimable ? 'Забрать награду' : timeLeft)}
              </button>
            </>
          )}
        </>
      )}
    </div>
  );
}